import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  headingText: {
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    fontSize: "24px",
    fontWeight: "600",
    lineHeight: "23px",
    letterSpacing: "0.01em",
    textAlign: "left",
  },
  tableGrid: {
    marginTop: "1%",
    backgroundColor: "#fff",
    border: "1px solid rgba(152, 152, 152, 1)",
    padding: 20,
    borderRadius: "4px",
  },
  tableHeadRow: {
    background: "rgba(58, 149, 255, 1)",
    borderRadius: "4px",
    padding: 10,
    borderLeft: "none",
  },
  tableHeadCell: {
    fontFamily: "'Roboto', sans-serif !important",
    fontSize: "14px !important",
    fontWeight: "700 !important",
    lineHeight: "19px !important",
    letterSpacing: "0.01em !important",
    textAlign: "left !important",
    color: "#fff !important",
    paddingTop: "10px !important",
    paddingBottom: "10px !important",
    borderBottom: "none !important",
  },
  tableBodyCell: {
    fontFamily: "'Roboto', sans-serif",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "19px",
    letterSpacing: "0.01em",
    textAlign: "left",
    color: "rgba(88, 92, 96, 1)",
    paddingTop: 15,
    paddingBottom: 15,
    borderLeft: "none",
    borderBottom: "none !important",
    boxShadow: "inset 0px -1px 0px rgba(224, 224, 224, 1)",
  },
  pagination: {
    "& .MuiPaginationItem-root": {
      "&.Mui-selected": {
        backgroundColor: "rgba(222, 229, 255, 1)",
        color: "rgba(27, 132, 253, 1)",
      },
      fontFamily: "Open Sans",
      fontSize: "13px",
      fontWeight: "600",
      lineHeight: "18px",
      letterSpacing: "0.09em",
      textAlign: "left",
    },
  },
  // NotifScrollBar
  scrollbar: {
    margin: 0,
    width: "370px",
    height: "464px",
    top: "68px",
    left: "1015px",
    padding: "5px",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "0.5em",
      border: "10px",
    },
    "&::-webkit-scrollbar-track": {
      borderRadius: "35px",
      borderStyle: "none",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#BABABA",
      borderRadius: "10%",
    },
  },
}));
export default useStyles;
